import styled from "styled-components/macro";

export const JobDiv = styled.div`
  background-color: white;
  display: flex;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
  justify-content: center;
`;

export const JobImg = styled.img`
  border-radius: 6px;
  width: 100%;
  height: auto;
`;

export const JobTitle = styled.h1`
  padding-top: 2em;
  text-align: left;
  font-size: ${(props) => props.theme.font.sizeBanner};
  font-weight: ${(props) => props.theme.font.weightMedium};
  font-family: ${(props) => props.theme.font.family};
  color: ${(props) => props.theme.colors.text};
`;

export const BlogGrid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;

  margin-top: 1rem;
  @media ${(props) => props.theme.media.phone} {
    margin: 0;
  }
`;

export const JobSection = styled.section`
  display: grid;
  grid-template-columns: 1fr;

  padding: 0 32px 40px;
  max-width: 120vh;
  color: ${(props) => props.theme.colors.text};

  & > h2 {
    margin-top: 40px;
    font-size: 24px;
    text-align: left;
  }

  & > section p {
    text-align: left;
  }

  & > section {
    padding-left: 0px;
  }
`;

export const ButtonSection = styled.div`
  margin-top: auto;
  display: flex;
  & button {
    font-size: 16px;
    margin-right: 16px;
  }
`;
